import { BrowserRouter } from "react-router-dom";
import RouteConfig from "./Routes/routeconfig";
import "./custom.css";

const baseUrl = process.env.PUBLIC_URL;

function App() {
  return (
    <>
      <BrowserRouter basename={baseUrl}>
        <RouteConfig />
      </BrowserRouter>
    </>
  );
}
export default App;
